import React from 'react';

function EirCustomiseBroadbandUpgrade(props) {

    return (
        <div >
            <div className={"upgrade-landline-details-ctr container "}>
                <h4 className="mt-mb-bb text-center">Upgrade your voice plan</h4>
                <div className="ap-config__accordion__bellow homephone-config ">
                    <div className="config-card config-card-plans"></div>
                </div>
            </div>
        </div>
    )

}

export default EirCustomiseBroadbandUpgrade;